import { render, staticRenderFns } from "./printingCount.vue?vue&type=template&id=6dcf0012&scoped=true&"
import script from "./printingCount.vue?vue&type=script&lang=js&"
export * from "./printingCount.vue?vue&type=script&lang=js&"
import style0 from "./printingCount.vue?vue&type=style&index=0&id=6dcf0012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf0012",
  null
  
)

export default component.exports